import React from 'react';

export enum SpinnerColor {
  Blue,
  White,
  Red,
}
interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  height: string;
  width: string;
  containerClassName?: string;
  spinnerColor?: SpinnerColor;
}

const SPINNER_VIEWBOX_SIZE = 50;
const SPINNER_CENTER = SPINNER_VIEWBOX_SIZE / 2;
const SPINNER_RADIUS = 20;
const SPINNER_STROKE_WIDTH = 3.6;
const SPINNER_STROKE_WIDTH_SMALL = 4.5;
const SPINNER_SMALL_SIZE_THRESHOLD_PX = 20;

const parseSizeToPx = (value: string): number => {
  const match = /^(-?\d*\.?\d+)(px|rem)?$/.exec(value.trim());
  if (!match) return NaN;
  const num = parseFloat(match[1]);
  return match[2] === 'rem' ? num * 16 : num;
};

export const Spinner = ({
  height,
  width,
  containerClassName,
  spinnerColor,
  ...rest
}: SpinnerProps) => {
  const getSpinnerColor = () => {
    switch (spinnerColor) {
      case SpinnerColor.Blue:
        return 'stroke-outline-brand-primary';
      case SpinnerColor.White:
        return 'stroke-outline-primary-bw-00';
      case SpinnerColor.Red:
        return 'stroke-outline-negative-primary';

      default:
        return 'stroke-outline-primary-bw-00';
    }
  };
  const sizePx = parseSizeToPx(width);
  const strokeWidth =
    !Number.isNaN(sizePx) && sizePx <= SPINNER_SMALL_SIZE_THRESHOLD_PX
      ? SPINNER_STROKE_WIDTH_SMALL
      : SPINNER_STROKE_WIDTH;
  return (
    <div
      data-testid='spinner'
      className={`w-full !pl-0 h-full flex justify-center items-center relative ${containerClassName}`}
      {...rest}>
      <svg
        className='chase-spinner animate-chaseRot'
        style={{ width, height }}
        viewBox={`0 0 ${SPINNER_VIEWBOX_SIZE} ${SPINNER_VIEWBOX_SIZE}`}
        fill='none'
        role='status'
        aria-label='Loading'>
        <circle
          cx={SPINNER_CENTER}
          cy={SPINNER_CENTER}
          r={SPINNER_RADIUS}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          className={`chase-spinner-arc animate-chaseDash ${getSpinnerColor()}`}
        />
      </svg>
    </div>
  );
};
